import CounselorSlider from './components/CounselorSlider.vue';
import InitComponent from 'Modules/InitComponent';
import store from 'Stores/store';

const counselorSlider = document.querySelectorAll('.counselor-slider__app');
const initComponent = new InitComponent({
  selectors: counselorSlider,
  components: { CounselorSlider },
  template: '<CounselorSlider />',
  store,
});

initComponent.init();
